module.exports = __webpack_public_path__ + "img/40_38_036_770.bf9506ba.jpg";